exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n    background-color: #023046;\n    margin-top: 40px;\n}\n\n.footer div {\n    text-align: center;\n    font-size: .8em;\n}\n\n.footer div div {\n    white-space: nowrap;\n}\n\n.footer div div a {\n    color: #ffffff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main